module.exports = __webpack_public_path__ + "static/img/ls42.d887562.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls42.png
// module id = ESbN
// module chunks = 12